import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'

export const SendInwardByEmail = ({ ticket, children }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const SendTicketInwardByEmailWithPDF = () => {
    setLoading(true)
    new rest.TicketService(ticket.url)
      .send_ticket_details_by_email_with_pdf()
      .then(() => {
        dispatch(showSuccessToast('Sent Ticket Details By Email With PDF'))
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        dispatch(showErrorToast('Could not Send Ticket Details By Email'))
      })
  }

  return (
    <ReactBootstrap.Dropdown.Item size={"sm"}
      onClick={() => SendTicketInwardByEmailWithPDF()}
    >
      {loading ? (
        <components.Loading />
      ) : (
        'Send Inward Details By Email With PDF'
      )}
    </ReactBootstrap.Dropdown.Item>
  )
}
